import { axiosGet, axiosDownload } from "./axiosFunctions";
import { getTokenOrLogout } from "./common";

const downloadPDFUrl              = (clientId) => `/api/tpa/file/downloadPDF/${clientId}`
const downloadVideoUrl            = (clientId) => `/api/tpa/file/downloadVideo/${clientId}`

export const downloadPDF = async (clientId) => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);  
  
    const response = await axiosGet(
        downloadPDFUrl(clientId),
        {
            headers: {
                auth_token: `bearer ${token}`               
            }
        }
    )
    return response
}

export const downloadVideo = async (clientId) => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);  
       
    const response = await axiosDownload(
        downloadVideoUrl(clientId),
        {
            headers: {
                auth_token: `bearer ${token}`               
            }
        }
    )
    return response
}